import React, { useEffect } from 'react';
import { DateTimeFormat } from '@/utils/moment';
import { Button, Form, Modal, ModalProps } from 'antd';
import moment, { Moment } from 'moment';
import { FormattedMessage } from 'react-intl';
import FilterByDatesFields from './FilterByDatesFields';
import RegisterDataWorkOrder from './RegisterDataWorkOrder';
import RegisterDataAccountReceivable from './RegisterDataAccountReceivable';
import { AccountReceivableListRequest } from '@/core/domain/financial/AccountReceivable/AccountReceivable.types';

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: () => void;
  handleSetFilter: (values: AccountReceivableListRequest) => void;
  queryParams?: AccountReceivableListRequest;
}

interface InstallmentsAdvancedFilterFormValues {
  accidentNumber: string;
  bankAccountId: number;
  costCenterId: number;
  documentNumber: string;
  licensePlate: string;
  workOrderNumber: string;
  initialDueDate: Moment;
  finalDueDate: Moment;
  initialPayDate: Moment;
  finalPayDate: Moment;
  initialEmissionDate: Moment;
  finalEmissionDate: Moment;
}

const AccountReceivableAdvancedModalFilters: React.FC<Props> = ({
  open,
  onCancel,
  handleSetFilter,
  queryParams,
}) => {
  const [form] = Form.useForm<InstallmentsAdvancedFilterFormValues>();

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const onCallback = async () => {
    const values = await form.validateFields();

    handleSetFilter({
      ...values,
      initialDueDate: values?.initialDueDate?.format(DateTimeFormat),
      finalDueDate: values?.finalDueDate?.format(DateTimeFormat),
      initialPayDate: values?.initialPayDate?.format(DateTimeFormat),
      finalPayDate: values?.finalPayDate?.format(DateTimeFormat),
      initialEmissionDate: values?.initialEmissionDate?.format(DateTimeFormat),
      finalEmissionDate: values?.finalEmissionDate?.format(DateTimeFormat),
    });

    onCancel();
  };

  useEffect(() => {
    if (queryParams) {
      form.setFieldsValue({
        ...queryParams,
        initialDueDate:
          queryParams.initialDueDate && moment(queryParams.initialDueDate),
        finalDueDate:
          queryParams.finalDueDate && moment(queryParams.finalDueDate),
        initialPayDate:
          queryParams.initialPayDate && moment(queryParams.initialPayDate),
        finalPayDate:
          queryParams.finalPayDate && moment(queryParams.finalPayDate),
        initialEmissionDate:
          queryParams.initialEmissionDate &&
          moment(queryParams.initialEmissionDate),
        finalEmissionDate:
          queryParams.finalEmissionDate &&
          moment(queryParams.finalEmissionDate),
      });
    }
  }, []);

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      title="Filtros Avançados"
      footer={[
        <Button type="primary" ghost onClick={handleCancel}>
          <FormattedMessage id="commons.modal.button.cancel" />
        </Button>,
        <Button type="primary" onClick={onCallback}>
          Pesquisar
        </Button>,
      ]}
      width={1000}
    >
      <Form form={form}>
        <RegisterDataWorkOrder />

        <RegisterDataAccountReceivable />

        <FilterByDatesFields />
      </Form>
    </Modal>
  );
};

export default AccountReceivableAdvancedModalFilters;
